<template>
  <div>
    <mdb-container class="mt-5 content-area viral-finder mt-5">
      <PageHeader text="Viral Finder"></PageHeader>

      <div class="d-flex justify-content-center mt-5" v-if="isLoading">
        <div class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class v-if="!isLoading">
        <mdb-alert
          v-if="showAlert"
          class="d-flex justify-content-center"
          color="danger"
        >
          <b>Oh no,</b>
        </mdb-alert>
        <ViralFinderSearchForm></ViralFinderSearchForm>
      </div>

      <div v-if="!igResultsEmpty && !isLoading">
        <hr />
        <h4 class="text-center">Settings</h4>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-2">
            <mdb-dropdown class="mb-3">
              <mdb-dropdown-toggle slot="toggle" color="primary" size="sm"
                >Sort by</mdb-dropdown-toggle
              >
              <mdb-dropdown-menu>
                <mdb-dropdown-item
                  v-on:click="
                    sortBy = 'likes';
                    sortMedia();
                  "
                  :class="sortBy === 'likes' ? 'active' : ''"
                  >Likes count</mdb-dropdown-item
                >
                <mdb-dropdown-item
                  v-on:click="
                    sortBy = 'comments';
                    sortMedia();
                  "
                  :class="sortBy === 'comments' ? 'active' : ''"
                  >Comments count</mdb-dropdown-item
                >
                <mdb-dropdown-item
                  v-on:click="
                    sortBy = 'engagement';
                    sortMedia();
                  "
                  :class="sortBy === 'engagement' ? 'active' : ''"
                  >Engagement rate</mdb-dropdown-item
                >
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </div>

          <div class="col-12 col-sm-6 col-md-8">
            <mdb-tooltip trigger="hover" :options="{ placement: 'top' }">
              <span slot="tip">
                How much more engagement the post should have than the average
                engagement is.
                <br />Example: average engagement is 20, the engagement
                multiplier is x2.0. You will only see posts with an engagement
                more or equal to 40.
              </span>
              <p class="small text-center mb-0" slot="reference">
                Engagement multiplier
                <i class="far fa-question-circle text-muted small" />
              </p>
            </mdb-tooltip>

            <div class="d-flex">
              <input
                type="range"
                min="1"
                max="3"
                step="0.1"
                v-model="engagementMultiplier"
                class="custom-range"
                v-on:change="filterByEngagement"
                id="customRange1"
              />
              <label for="customRange1" class="ml-2"
                >x{{ engagementMultiplier }}</label
              >
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-2">
            <p class="text-center small">Post type</p>
            <div class="checkboxes">
              <div>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    v-model="includeImages"
                    v-on:change="filterByMediaType(true)"
                    class="custom-control-input"
                    id="images"
                  />
                  <label class="custom-control-label" for="images"
                    >Images</label
                  >
                </div>
              </div>

              <div>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    v-model="includeVideos"
                    v-on:change="filterByMediaType(true)"
                    class="custom-control-input"
                    id="videos"
                  />
                  <label class="custom-control-label" for="videos"
                    >Videos</label
                  >
                </div>
              </div>
              <div>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    v-model="includeCarousel"
                    v-on:change="filterByMediaType(true)"
                    class="custom-control-input"
                    id="carousel"
                  />
                  <label class="custom-control-label" for="carousel"
                    >Carousel</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="mt-5 w-100" v-if="media.length === 0">
            <mdb-alert class="d-flex justify-content-center" color="danger">
              <b>Oh no,</b> we could'nt find any posts
            </mdb-alert>
          </div>
          <div
            v-for="post in media"
            :key="post.permalink"
            class="col-12 col-sm-6 col-md-4"
          >
            <InstagramPost
              :post="post"
              :follower="getIgResult.business_discovery.followers_count"
            ></InstagramPost>
          </div>
        </div>
      </div>
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbAlert,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbTooltip,
} from "mdbvue";
import PageHeader from "../../../components/PageHeader";
import ViralFinderSearchForm from "../../../components/viral-finder/ViralFinderSearchForm";
import InstagramPost from "../../../components/viral-finder/InstagramPost";
export default {
  name: "ViralFinder",
  components: {
    mdbContainer,
    mdbAlert,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbTooltip,
    PageHeader,
    ViralFinderSearchForm,
    InstagramPost,
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["ui/isLoading"];
    },
    getIgResult: function() {
      return this.$store.getters["igViralFinder/igResults"];
    },
    igResultsEmpty: function() {
      return (
        Object.entries(this.$store.getters["igViralFinder/igResults"])
          .length === 0
      );
    },
    media: function() {
      return this.$store.getters["igViralFinder/igMedia"];
    },
  },
  methods: {
    isVideo: function() {},
    sortMedia: function() {
      this.$store.commit("igViralFinder/sort_ig_media", this.sortBy);
      this.filterByEngagement();
    },
    filterByEngagement: function() {
      this.$store.commit(
        "igViralFinder/filter_ig_media_by_engagement",
        this.engagementMultiplier
      );

      this.filterByMediaType(false);
    },
    filterByMediaType: function(resetFilter) {
      if (resetFilter === true) {
        this.filterByEngagement();
      }

      const payload = {
        includeImages: this.includeImages,
        includeVideos: this.includeVideos,
        includeCarousel: this.includeCarousel,
      };

      this.$store.commit("igViralFinder/filter_ig_media_by_type", payload);
    },
  },
  data() {
    return {
      code: 0,
      fbAuth: {},
      isError: false,
      showAlert: false,
      sortBy: "engagement",
      engagementMultiplier: 1,
      includeImages: true,
      includeVideos: true,
      includeCarousel: true,
    };
  },
  created: function() {},
};
</script>
